import { render } from "./LogsList.vue?vue&type=template&id=048e4edf"
import script from "./LogsList.vue?vue&type=script&lang=js"
export * from "./LogsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/common/sys/logs/LogsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "048e4edf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('048e4edf', __exports__)) {
    api.reload('048e4edf', __exports__)
  }
  
  module.hot.accept("./LogsList.vue?vue&type=template&id=048e4edf", () => {
    api.rerender('048e4edf', render)
  })

}


export default __exports__